export default __webpack_public_path__ + "assets/community-two-three-small.75e92e576ab8840086ca235fc6531d95.png";